import { Label } from '@/components/base/label'
import type { SwitchProps } from '@/components/base/switch'
import { Switch } from '@/components/base/switch'
import { DEBOUNCE_MEDIA_CONSTRAINTS_MS } from '@/helpers/constants'
import { useOptimisticUpdateWithPromise } from '@/hooks/useOptimisticUpdateWithPromise'
import { useRoomStoreActions } from '@/stores/room'
import { useCallback, useId } from 'react'

type SwitchEchoCancellationProps = Omit<
  SwitchProps,
  'checked' | 'id' | 'onCheckedChange'
> & {
  echoCancellation: boolean
  memberId: string
}

export const SwitchEchoCancellation = ({
  echoCancellation,
  memberId,
  ...props
}: SwitchEchoCancellationProps) => {
  const { partialUpdateMicrophone } = useRoomStoreActions()

  const echoCancellationId = useId()

  const handleUpdateCallback = useCallback(
    (value: boolean) => {
      return partialUpdateMicrophone({
        constraints: { echoCancellation: value },
        memberId,
      })
    },
    [memberId, partialUpdateMicrophone],
  )

  const { optimisticValue, handleUpdate } = useOptimisticUpdateWithPromise(
    echoCancellation,
    handleUpdateCallback,
    DEBOUNCE_MEDIA_CONSTRAINTS_MS,
  )

  return (
    <>
      <Label htmlFor={echoCancellationId}>Echo Cancellation</Label>
      <Switch
        id={echoCancellationId}
        checked={optimisticValue}
        onCheckedChange={handleUpdate}
        {...props}
      />
    </>
  )
}
